(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-mm-mega]').forEach((menu) => {
      if (menu.dataset.mmMegaReady) return;
      menu.dataset.mmMegaReady = 'true';
      const trigger = menu.querySelector('summary');
      const header = menu.closest('[data-mm-header]');
      const hover = window.matchMedia('(hover: hover) and (min-width: 750px)');
      let closeTimer;
      const sync = () => trigger.setAttribute('aria-expanded', String(menu.open));
      const cancelClose = () => window.clearTimeout(closeTimer);
      const close = () => { menu.open = false; sync(); };
      trigger.addEventListener('pointerenter', (event) => {
        if (!hover.matches || event.pointerType === 'touch') return;
        cancelClose();
        menu.open = true;
        sync();
      });
      trigger.addEventListener('click', (event) => {
        if (!hover.matches || event.detail === 0 || event.pointerType === 'touch') return;
        event.preventDefault();
        if (trigger.dataset.mmShopUrl) {
          window.location.href = trigger.dataset.mmShopUrl;
          return;
        }
        cancelClose();
        menu.open = true;
        sync();
      });
      menu.addEventListener('pointerenter', cancelClose);
      header.addEventListener('pointerenter', cancelClose);
      header.addEventListener('pointerleave', () => {
        if (hover.matches) closeTimer = window.setTimeout(close, 180);
      });
      menu.addEventListener('toggle', sync);
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' && event.target === trigger) {
          event.preventDefault();
          menu.open = true;
          sync();
          menu.querySelector('.mm-mega-panel a')?.focus();
        } else if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          cancelClose();
          close();
          trigger.focus();
        }
      });
      menu.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!menu.contains(document.activeElement)) close();
        }, 0);
      });
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
